import request from "@/utils/request.js";
// 实有人口性别
export const prisonlist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/prisonSex",
    params: data || {}
  });
};
// 实有人口 人口一致表示
export const prisonHouseHoldType = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/prisonHouseHoldType",
    params: data || {}
  });
};
// 实有房屋
export const houselist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/house",
    params: data || {}
  });
};
// 实有单位
export const unitlist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/unit",
    params: data || {}
  });
};
// 实有安防
export const securitylist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/security",
    params: data || {}
  });
};
// 实有力量
export const strengthlist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/strength",
    params: data || {}
  });
};
// 实有装备
export const equipmentlist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/equipment",
    params: data || {}
  });
};

// 实有警情事件
export const eventlist = data => {
  return request({
    url: "/api/hz-smart-community/onethree/overview/event",
    params: data || {}
  });
};

// 实有安防设施添加
export const securitysave = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/save",
    data: data || {},
    method: "POST"
  });
};